// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//EN ENTORNO MULTI, HABILITAR:
// apiUrl: 'https://devmavalue.plataforma-smart.com'
// apiBillma: 'https://pre2-billma.plataforma-smart.com',
// ENTORNO GARAJE:
//apiUrl: 'https://ndbx-selfcare.multiasistencia.garajedeideas.es',
//apiBillma: 'https://ndbx-selfcare.multiasistencia.garajedeideas.es',

export const environment = {
  production: false,
  apiUrl: 'https://devmavalue.plataforma-smart.com',
  //apiUrl: 'https://ndbx-selfcare.multiasistencia.garajedeideas.es',
  apiBillma: 'https://pre2-billma.plataforma-smart.com',
  //apiBillma: 'https://devmavalue.plataforma-smart.com',
  //apiBillma: 'https://ndbx-selfcare.multiasistencia.garajedeideas.es',
  apiGoogle: 'AIzaSyDEBInSa5pTVUH8P_Zx8TAGw-NDuuHLhgI', //ONLY FOR LOCAL TESTING, CHANGE BEFORE DEPLOY
  s3Url: 'https://devmavalue.plataforma-smart.com/staticontents/assets',
  adobeUrl: 'https://assets.adobedtm.com/dd4adce84cad/23557c1a8408/launch-e173f7a3916d.min.js'

  //s3Url: 'https://garaje-de-ideas-multiasistencia-dev-i9demy4g.s3.eu-west-1.amazonaws.com/assets'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI
